import { getMyEssays } from '../queries/essayFunction';
import { useEssayListStore } from '../stores/essayListStore';
import { useMutation } from '@tanstack/react-query';

export function useGetEssays() {
  const { setEssays } = useEssayListStore();
  const { mutate, isError, error, isPending } = useMutation({
    mutationKey: ['MyEssay'], 
    mutationFn: () => getMyEssays(), 
    onSuccess: (response) => {
      setEssays(response)
    },
    retry: false
  });

  return { isError, isPending, error, mutate }
}